import { DefaultButton, PrimaryButton, TextField, Toggle } from "@fluentui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../Constants/AppRoutes";
import { emailListError } from "../../Models/IUser";
import { IAPIResponse } from "../../Services/AjaxService";
import ApiService from "../../Services/ApiService";
import { ToastMessage } from "../../Utils/UIMessages";
import "./OwnEmailPanel.scss";

// SSL Cloud: chi usa il sistema (un familiare, una badante) cambia da sé le email dove riceve gli allarmi e la
// propria password (decisione del 26/10/2026). Solo i propri dati: ruoli e Attivo restano a chi amministra.
const OwnEmailPanel = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [saved, setSaved] = useState<{ email: string; on: boolean }>({ email: "", on: true });
  const [email, setEmail] = useState<string>("");
  const [on, setOn] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    ApiService.UsersController.GetOwnEmail((response: IAPIResponse) => {
      if (response.error === null && response.parsed) {
        const e = response.parsed.email ?? "";
        const n = response.parsed.emailNotifications !== false;
        setSaved({ email: e, on: n });
        setEmail(e);
        setOn(n);
      }
      setLoaded(true);
    });
  }, []);

  const error = emailListError(email);
  const changed = email.trim() !== saved.email.trim() || on !== saved.on;

  const save = () => {
    if (error || !changed || saving) return;
    setSaving(true);
    ApiService.UsersController.SaveOwnEmail(
      { email: email.trim() || null, emailNotifications: on },
      (response: IAPIResponse) => {
        setSaving(false);
        if (response.error === null) {
          const e = response.parsed?.email ?? email.trim();
          setSaved({ email: e, on });
          setEmail(e);
          ToastMessage("success", "Email degli allarmi salvate.");
        } else {
          ToastMessage("error", "Impossibile salvare le email: " + response.error);
        }
      }
    );
  };

  if (!loaded) return null;
  return (
    <div>
      <div className="app-generic-title">Le mie email degli allarmi</div>
      <TextField
        ariaLabel="Email dove ricevere gli allarmi"
        placeholder="es. mario@esempio.it, anna@esempio.it"
        value={email}
        errorMessage={error}
        onChange={(e, v) => setEmail(v ?? "")}
      />
      {!error && <div className="own-email-help">Puoi inserire fino a 5 email, separate da virgola.</div>}
      <Toggle
        className="own-email-toggle"
        inlineLabel
        label="Invia gli allarmi per email"
        checked={!!email.trim() && on}
        disabled={!email.trim()}
        onText="Sì"
        offText={email.trim() ? "No" : "No: scrivi prima un'email"}
        onChange={(e, c) => setOn(!!c)}
      />
      <div className="own-email-actions">
        <PrimaryButton
          text={saving ? "Salvataggio..." : "Salva"}
          disabled={!!error || !changed || saving}
          onClick={save}
        />
        {!changed && !saving && <span className="own-email-help">Nessuna modifica da salvare</span>}
      </div>
      <DefaultButton
        className="own-email-password"
        iconProps={{ iconName: "Lock" }}
        text="Cambia la mia password"
        onClick={() => navigate(AppRoutes.APP_RESET_PASSWORD_PAGE)}
      />
    </div>
  );
};

export default OwnEmailPanel;
